import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { invalidateTruckShiftQueries } from 'src/hooks/invalidateTruckShiftQueries';

export const IMPORT_PATH = '/api/v5/truck_shifts/import';

export type ImportErrorRow = { row: number; message: string };
export type ImportPreviewResult = {
  create_count: number;
  update_count: number;
  skip_count: number;
  error_rows: ImportErrorRow[];
  warnings: string[];
};
export type ImportCommitResult = {
  created: number;
  updated: number;
  skipped: number;
  errors: ImportErrorRow[];
};

export const formatCommitSummary = (result: ImportCommitResult): string => {
  const base = `${result.created}件作成・${result.updated}件更新`;
  const skip = result.skipped > 0 ? `・${result.skipped}件スキップ` : '';
  const err = result.errors.length > 0 ? `（${result.errors.length}件エラー）` : '';
  return `${base}${skip}${err}`;
};

export const useMutationTruckShiftImport = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ file, commit }: { file: File; commit: boolean }): Promise<ImportPreviewResult | ImportCommitResult> => {
      const data = new FormData();
      data.append('file', file);
      data.append('commit', String(commit)); // boolean を直接入れず 'true'/'false' に明示
      const response = await axios.post<ImportPreviewResult | ImportCommitResult>(IMPORT_PATH, data);
      return response.data;
    },
    {
      // 反映(commit:true)時のみグリッドを更新。プレビュー(commit:false)は書込なしなので invalidate しない。
      onSuccess: (_data, variables) => {
        if (variables.commit) invalidateTruckShiftQueries(queryClient);
      },
    },
  );
};
